import { functionsBase } from '../config/functionsBase';

const FUNCTIONS_BASE = functionsBase(
  process.env.NODE_ENV === 'production'
    ? '/.netlify/functions'
    : 'http://localhost:8891/.netlify/functions'
);

/**
 * Cria sessão Stripe Checkout (cartão / assinatura) e retorna { url, sessionId }.
 */
export async function createCheckoutSession({
  planId,
  billing,
  discordId,
  discordUsername,
  minecraftNick,
  promoCode,
}) {
  const response = await fetch(`${FUNCTIONS_BASE}/create-checkout-session`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      planId,
      billing,
      discordId,
      discordUsername,
      minecraftNick,
      promoCode: promoCode || undefined,
    }),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.error || `Erro no checkout (${response.status})`);
  }

  if (!data.url) {
    throw new Error('URL de checkout não retornada');
  }

  return data;
}

/**
 * Valida cupom / código de creator e retorna preço com desconto (ou promo VIP automática).
 */
export async function validatePromoCode({ planId, billing, code, appliesTo = 'vip' }) {
  const response = await fetch(`${FUNCTIONS_BASE}/validate-promo-code`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      planId,
      billing,
      code: code || '',
      appliesTo,
    }),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || `Código inválido (${response.status})`);
  }
  return data;
}

/** Preços públicos atuais dos planos VIP. */
export async function fetchVipPricing() {
  const response = await fetch(`${FUNCTIONS_BASE}/vip-pricing`);
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || `Erro ao carregar preços (${response.status})`);
  }
  return data;
}
